import { useState, useEffect, useCallback } from "react";
import "../../../assets/css/reservation.css";
import { useNavigate } from "react-router-dom";
import { ReservationsController } from "../../../controllers/reservationsController";
import { ApiUtil } from "../../../util/apiUtil";
import { Button } from "react-bootstrap";
import { Loading } from "../../../components/loading";
import { TableName } from "../../../constants/tableName";
import { TableListStatus } from "../../../components/tableListStatus";
import { ReservationPreview } from "./reservationPreview";
import { UsersController } from "../../../controllers/usersController";
import { Dropdown } from "../../../components/dropdown";

export const AllReservationsList = ({
  isOpen = false,
  reservationSettingsId,
  reservationType = TableName.NORMALRESERVATIONS,
  backFunction = () => {},
  minDate,
  maxDate,
}) => {
  const navigate = useNavigate();
  const [user] = useState(() => JSON.parse(localStorage.getItem("user")));
  const [loading, setLoading] = useState(true);
  const [normalReservations, setNormalReservations] = useState([]);
  const [eventReservations, setEventReservations] = useState([]);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [reservationDate, setReservationDate] = useState("");
  const [filter, showFilter] = useState(false);
  const handlePopupDialogOpen = (data) => {
    setSelectedData(data);
    setIsPreviewOpen(true);
  };
  const handlePreviewClose = () => {
    setIsPreviewOpen(false);
  };
  const getAllNormalReservations = () => {
    return new Promise((resolve, reject) => {
      ReservationsController.getAll({
        type: TableName.NORMALRESERVATIONS,
        reservationSettingsId: reservationSettingsId,
        resolve: resolve,
        reject: reject,
      });
    });
  };
  const getAllEventReservations = () => {
    return new Promise((resolve, reject) => {
      ReservationsController.getAll({
        type: TableName.EVENTRESERVATIONS,
        reservationSettingsId: reservationSettingsId,
        resolve: resolve,
        reject: reject,
      });
    });
  };
  const getAllReservations = () => {
    Promise.all([getAllNormalReservations(), getAllEventReservations()])
      .then(async ([normalReservationsData, eventReservationsData]) => {
        const normalData = ApiUtil.deserialize({
          data: normalReservationsData,
        });
        const eventData = ApiUtil.deserialize({
          data: eventReservationsData,
        });
        const updatedNormalData = await Promise.all(
          normalData.map(async (data) => {
            const user = ApiUtil.deserialize({
              data: await getUserDetail(data),
            });
            return {
              ...data,
              slotTitle: data.timeSlot.slotTitle,
              timeSlot: `${data.timeSlot.startTime} - ${data.timeSlot.endTime}`,
              fullName: `${user?.firstName} ${user?.lastName}`,
              contactNum: user?.contactNum,
              reservationDate: data.reservationDate,
            };
          })
        );
        const updatedEventData = await Promise.all(
          eventData.map(async (data) => {
            const user = ApiUtil.deserialize({
              data: await getUserDetail(data),
            });
            return {
              ...data,
              slotTitle: data.timeSlot.slotTitle,
              timeSlot: `${data.timeSlot.startTime} - ${data.timeSlot.endTime}`,
              fullName: `${user?.firstName} ${user?.lastName}`,
              contactNum: user?.contactNum,
              reservationDate: data.reservationDate,
            };
          })
        );
        setNormalReservations(updatedNormalData);
        setEventReservations(updatedEventData);
      })
      .catch((error) => console.debug(error))
      .finally(() => setLoading(false));
  };
  const getUserDetail = (reservations) => {
    return new Promise((resolve, reject) => {
      UsersController.get({
        userId: reservations.userId,
        resolve,
        reject,
      });
    });
  };
  const handleOnChange = useCallback((value) => {
    setReservationDate(value);
  }, []);
  const generateDateOptions = (startDate, endDate) => {
    const options = [];
    const currentDate = new Date(startDate);
    const end = new Date(endDate);
    while (currentDate <= end) {
      const dateString = currentDate.toISOString().split("T")[0];
      options.push({ value: dateString, label: dateString });
      currentDate.setDate(currentDate.getDate() + 1);
    }
    return options;
  };
  const filteredReservations =
    reservationType === TableName.NORMALRESERVATIONS
      ? normalReservations.filter(
          (reservation) =>
            !reservationDate || reservation.reservationDate === reservationDate
        )
      : eventReservations.filter(
          (reservation) =>
            !reservationDate || reservation.reservationDate === reservationDate
        );
  useEffect(() => {
    getAllReservations(reservationSettingsId);
  }, []);
  useEffect(() => {
    if (!user) navigate("/loginSignUp", { state: { isLoginToggle: true } });
  }, [user]);
  useEffect(() => {
    if (
      isOpen &&
      reservationSettingsId &&
      reservationType &&
      minDate &&
      maxDate
    ) {
      setLoading(false);
    }
  }, [isOpen, reservationSettingsId, reservationType, minDate, maxDate]);

  return loading ? (
    <Loading />
  ) : (
    <section id="allReservationsList">
      <div className="reservation-container">
        <div>
          <h3>{`ALL ${
            reservationType === TableName.NORMALRESERVATIONS
              ? "NORMAL"
              : "EVENT"
          } RESERVATIONS LIST`}</h3>
          <hr />
          <div className="web-details">
            <Button onClick={() => showFilter(!filter)}>
              {filter ? "HIDE" : "FILTER"}
            </Button>
          </div>
          <form className="margin-bottom">
            {filter && (
              <Dropdown
                name="reservationDate"
                title="Reservation Date"
                value={reservationDate}
                options={generateDateOptions(minDate, maxDate)}
                isClearable={true}
                onChangeFunc={handleOnChange}
                isMandatory={false}
                placeholder="All"
              />
            )}
            <TableListStatus
              list={filteredReservations}
              type={reservationType}
              isFilter={filter}
              handlePopupDialogOpen={handlePopupDialogOpen}
            />
          </form>
        </div>
        <ReservationPreview
          user={user}
          type={reservationType}
          isOpen={isPreviewOpen}
          handleClose={handlePreviewClose}
          getAll={() => getAllReservations(reservationSettingsId)}
          selectedData={selectedData}
        />
      </div>
      <div className="button-container stick-bottom">
        <Button onClick={backFunction}>BACK</Button>
        <Button
          onClick={() => getAllReservations(reservationSettingsId)}
          className="arrow-button"
        >
          REFRESH
        </Button>
      </div>
    </section>
  );
};
